import { CategoryModel } from '../../services/content/category/models/CategoryModel';
import { MetaDataModel } from '../../services/content/meta/models/MetaDataModel';
import React, { FunctionComponent, PropsWithChildren } from 'react';
import { useRouter } from 'next/router';
import { SectionLeadingContent } from '../Section/SectionLeadingContent';
import { SectionSecondaryContent } from '../Section/SectionSecondaryContent';
import { Pagination } from '../Partials/Pagination/Pagination';
import { GoogleAdDesktop } from '../Ads/GoogleAdDesktop';
import { AdBackground } from '../Ads/AdBackground';
import { GoogleAdMobile } from '../Ads/GoogleAdMobile';
import { ads } from '../../services/ads/constants';
import { ArticlePartialModel } from '../../services/content/article/models/ArticlePartialModel';

type Props = {
    articles: ArticlePartialModel[];
    leadingArticles: ArticlePartialModel[];
    currentCategory: CategoryModel;
    meta: MetaDataModel | null;
    page: string;
    slug: string;
};
export const CategoryMainPage: FunctionComponent<Props> = ({
    articles,
    leadingArticles,
    currentCategory,
    meta,
    page,
    slug,
}) => {
    const router = useRouter();

    return (
        <>
            <div className='row mb-4'>
                <div className='col-12 col-md-9'>
                    <SectionLeadingContent content={leadingArticles[0]} category={currentCategory} />
                </div>
                <div className='col-12 col-md-3'>
                    <div className='d-flex flex-column'>
                        {leadingArticles
                            .filter((article, idx) => idx > 0)
                            .map((article, idx) => {
                                return (
                                    <AdsMobileWrapperLeading key={`category-article-key-${article.id}`} idx={idx}>
                                        <SectionSecondaryContent
                                            className='mb-0 mb-md-4'
                                            content={article}
                                            category={article?.category}
                                        />
                                    </AdsMobileWrapperLeading>
                                );
                            })}
                    </div>
                </div>
            </div>
            <div className='row gx-0 px-0'>
                <div className='col-12 col-md-9'>
                    <div className='container px-0'>
                        <div className='row gx-3'>
                            {articles.map((article, idx) => {
                                return (
                                    <AdsMobileWrapperOther key={`category-article-key-${article.id}`} idx={idx}>
                                        <SectionSecondaryContent
                                            className={`col-md-4 col-12 mb-md-4`}
                                            content={article}
                                            category={article?.category}
                                        />
                                    </AdsMobileWrapperOther>
                                );
                            })}
                        </div>
                        <div className='w-100 text-center'>
                            <div className='d-inline-block d-md-none d-lg-none text-center'>
                                <AdBackground>
                                    <GoogleAdMobile ad={ads[13]} />
                                </AdBackground>
                            </div>
                        </div>
                    </div>
                    <div className='w-100 d-flex flex-row justify-content-end'>
                        <Pagination
                            meta={meta}
                            onPageClick={(page) => {
                                router.push(page > 1 ? `/${slug}/${page}` : `/${slug}`);
                            }}
                            page={page}
                        />
                    </div>
                </div>
                <div className='d-none d-md-block col-12 col-md-3 text-center'>
                    <AdBackground className='sticky-ad'>
                        <GoogleAdDesktop ad={ads[10]} />
                    </AdBackground>
                </div>
            </div>
        </>
    );
};

const AdsMobileWrapperLeading: FunctionComponent<PropsWithChildren<{ idx: number }>> = ({ children, idx }) => {
    const SECOND_ARTICLE = 0;

    if (SECOND_ARTICLE === idx) {
        return (
            <>
                {children}
                <div className='d-inline-block d-md-none d-lg-none text-center'>
                    <AdBackground className='sticky-ad'>
                        <GoogleAdMobile ad={ads[10]} />
                    </AdBackground>
                </div>
            </>
        );
    }

    return <>{children}</>;
};

const AdsMobileWrapperOther: FunctionComponent<PropsWithChildren<{ idx: number }>> = ({ children, idx }) => {
    const FOURTH_ARTICLE = 0;
    const SEVENTH_ARTICLE = 3;

    if (FOURTH_ARTICLE === idx) {
        return (
            <>
                {children}
                <div className='d-inline-block d-md-none d-lg-none text-center ad-container-h600'>
                    <AdBackground className='sticky-ad'>
                        <GoogleAdMobile ad={ads[11]} />
                    </AdBackground>
                </div>
            </>
        );
    }

    if (SEVENTH_ARTICLE === idx) {
        return (
            <>
                {children}
                <div className='d-inline-block d-md-none d-lg-none text-center'>
                    <AdBackground className='sticky-ad'>
                        <GoogleAdMobile ad={ads[12]} />
                    </AdBackground>
                </div>
            </>
        );
    }

    return <>{children}</>;
};
